import { render, staticRenderFns } from "./itemsRelatorio.vue?vue&type=template&id=181054c5&scoped=true&"
import script from "./itemsRelatorio.vue?vue&type=script&lang=js&"
export * from "./itemsRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./itemsRelatorio.vue?vue&type=style&index=0&id=181054c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181054c5",
  null
  
)

export default component.exports